module.exports = __webpack_public_path__ + "img/account-summary-card-white.4e4a779b.svg";